import React, { useContext, useState, useRef } from "react";

import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";

import ReactMarkdown from "react-markdown";
import { Accordion, AccordionContext, Container, Spinner } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";

import ExerciseWon from "../../../../image/happy-azeto.svg";
import ExerciseLose from "../../../../image/sad-azeto.svg";

import { startFethingExercise } from "../../../../redux/actions/singleSimDetail/singleSimDetailAction";
import {
  showDangerAlert,
  showSimAlert,
} from "../../../../redux/actions/alert/alertActions";
import userMessageType from "../../../../redux/actions/userMessage/userMessageType";

import scrollToTop from "../../../../libs/scrollToTop";
import { convertNumbersToEn } from "../../../../libs/convertNumbers";

import Simulator from "../sim/simulator";
import InputComponent from "../../form/input";

import {
  StyledTable,
  StyledAccordion,
  StyledChevronUpCircle,
  StyledExerciseAccordionItem,
  TableRow,
  ExerciseResultImg,
  ExerciseSubmitBtn,
} from "./styledExercise";

const ExerciseTabComponent = ({
  simID,
  isExcel,
  simSrc,
  ExerciseData,
  simulationData,
  postExerciseRequest,
}) => {
  const {
    exercisePostData,
    exercisePostError,
    exerciseIsLoaded,
    exerciseIsLoading,
    runPostExercise,
  } = postExerciseRequest;

  const dispatch = useDispatch();
  //exercise
  const [exerciseResultSubmited, setExerciseResultSubmited] = useState([]);
  const [exercisePercentSubmited, setExercisePercentSubmited] = useState("");
  const [isExercised, setIsExercised] = useState(false);

  const ContextAwareToggle = ({ title, eventKey, callback }) => {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey)
    );
    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <Accordion.Header onClick={decoratedOnClick}>
        <span className="accordion-title text-center">{title}</span>
        <StyledChevronUpCircle
          set="bold"
          primaryColor="var(--primary-color)"
          className="accordion-icon"
          size="large"
          $active={isCurrentEventKey}
        />
      </Accordion.Header>
    );
  };

  const exerciseFormRow = useRef(null);
  const ExerciseTable = () => {
    const [checkRowResult, setCheckRowResult] = useState(false);

    const { register, handleSubmit } = useForm();
    const dispatch = useDispatch();

    const handleSubmitExercise = (formValues) => {
      let exerciseDataArray = [];
      const data = {
        exercisedata_set: exerciseDataArray,
      };

      for (let key in formValues) {
        const inputValue = convertNumbersToEn(formValues[key]);
        if (inputValue === "" || inputValue === "default" || inputValue === ".") {
          dispatch(showDangerAlert("فیلد‌های تمرین نباید خالی باشد."));
          return;
        } else {
          exerciseDataArray.push({
            value: inputValue,
            parameter: key.split("-")[0],
            result: key.split("-")[1],
          });
        }
      }

      runPostExercise(data).then((response) => {
        setExerciseResultSubmited(response.data.result);
        setExercisePercentSubmited(response.data.percent);
        // handleCheckedExercise(response.data.result);
        setIsExercised(true);
        dispatch({ type: userMessageType.UPDATE_COUNT_UNREAD_MESSAGE });
      });
    };

    //FIXME
    // const exerciseFormRowTag = exerciseFormRow.current;
    // const handleCheckedExercise = (e) => {
    //   e.map((item) => {
    //     if (exerciseFormRow) {
    //       if (item.is_true === true) {
    //         exerciseFormRowTag.id === item.result_set &&
    //           exerciseFormRowTag.classList.add("check-is-true");
    //         document.getElementById(item.result_set).classList.add("check-is-true");
    //           itemResult_set: item.result_set,
    //           getID: document.getElementById(item.result_set),
    //           ref: exerciseFormRowTag,
    //         });
    //         document
    //           .getElementById(item.result_set)
    //           .classList.remove("check-is-false");
    //         // setCheckRowResult("check-is-true");
    //       } else {
    //           itemResult_set: item.result_set,
    //           getID: document.getElementById(item.result_set),
    //           ref: exerciseFormRowTag,
    //         });
    //         exerciseFormRowTag.id === item.result_set &&
    //           exerciseFormRowTag.classList.add("check-is-false");
    //         document.getElementById(item.result_set).classList.add("check-is-false");
    //         document
    //           .getElementById(item.result_set)
    //           .classList.remove("check-is-true");
    //         // setCheckRowResult("check-is-false");
    //       }
    //     }
    //   });
    // };

    const handleRedoExercise = () => {
      setIsExercised(false);
      setTimeout(() => {
        scrollToTop();
      }, 300);
      {
        // exerciseResultSubmited.map((item) => {
        //   exerciseFormRowTag.classList.remove("check-is-false");
        //   exerciseFormRowTag.classList.remove("check-is-true");
        // });
      }
      dispatch(startFethingExercise(simID));
    };

    return (
      <>
        <form
          onSubmit={handleSubmit(handleSubmitExercise)}
          autoComplete="off"
          className="overflow-auto p-3"
        >
          <StyledTable responsive bordered dir="ltr">
            <thead>
              <tr>
                {ExerciseData.parameter_set.map((itemParametrSet) => {
                  return (
                    <th key={itemParametrSet.id} className="text-nowrap p-md-4">
                      {itemParametrSet.name}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {ExerciseData.result_set.map((itemResultSet) => {
                return (
                  <React.Fragment key={itemResultSet.id}>
                    {/* <TableRow */}
                    <tr
                      id={itemResultSet.id}
                      ref={exerciseFormRow}
                      // $checked={checkRowResult}
                      className={checkRowResult ? `${checkRowResult}` : undefined}
                    >
                      {itemResultSet.is_example ? (
                        <>
                          {ExerciseData.exercisedata_set
                            .filter((item) => item.result === itemResultSet.id)
                            .map((it) => {
                              return (
                                <td key={it.id} className="p-1 p-md-2">
                                  {it.value}
                                </td>
                              );
                            })}
                        </>
                      ) : (
                        <>
                          {ExerciseData.exercisedata_set
                            .filter((item) => item.result === itemResultSet.id)
                            .map((it) => {
                              return (
                                <React.Fragment key={it.id}>
                                  <td>{it.value}</td>
                                </React.Fragment>
                              );
                            })}

                          {ExerciseData.parameter_set
                            .filter(
                              (isDependentItem) => !isDependentItem.is_independent
                            )
                            .map((dItem) => {
                              return (
                                <React.Fragment key={dItem.id}>
                                  {dItem.type === 0 ? (
                                    <td>
                                      <InputComponent
                                        register={register(
                                          `${dItem.id}-${itemResultSet.id}`,
                                          {
                                            pattern: "[0-9]",
                                          }
                                        )}
                                        id={itemResultSet.id}
                                        default="0.0"
                                        disabled={isExercised}
                                        containerClass="input-exercise w-75 mx-auto"
                                        className="text-center"
                                      />
                                    </td>
                                  ) : (
                                    <td className="px-2">
                                      <select
                                        {...register(
                                          `${dItem.id}-${itemResultSet.id}`
                                        )}
                                        id={itemResultSet.id}
                                        disabled={isExercised}
                                        defaultValue="default"
                                        className="input-exercise text-center bg-transparent"
                                      >
                                        <option value="default">انتخاب کنید</option>

                                        {dItem.option_set.map((optItem, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={optItem.name}
                                              id={itemResultSet.id}
                                              className="option-exercise"
                                            >
                                              {optItem.name}
                                            </option>
                                          );
                                        })}
                                      </select>
                                    </td>
                                  )}
                                </React.Fragment>
                              );
                            })}
                        </>
                      )}
                    </tr>
                    {/* </TableRow> */}
                  </React.Fragment>
                );
              })}
            </tbody>
          </StyledTable>
          {!exercisePostError ? (
            <div className="mt-4 text-center">
              {isExercised ? (
                <ExerciseSubmitBtn
                  type="submit"
                  variant="outline-primary"
                  className="text-primary px-4"
                  onClick={handleRedoExercise}
                >
                  تلاش مجدد
                </ExerciseSubmitBtn>
              ) : (
                <ExerciseSubmitBtn type="submit" className="px-4">
                  {exerciseIsLoading ? <Spinner animation="border" /> : "ثبت پاسخ"}
                </ExerciseSubmitBtn>
              )}
            </div>
          ) : (
            <div className="text-center mt-4">{exercisePostError}</div>
          )}
        </form>

        {isExercised && (
          <Container className="py-4">
            <div className="d-flex justify-content-around align-items-baseline text-primary">
              <div className="fs-3">
                <b className="text-center">نتیجه تمرین</b>
                <p>
                  درصد شما از این تمرین :<u>%{exercisePercentSubmited}</u>
                </p>
              </div>
              {exercisePercentSubmited > 50 ? (
                <div>
                  <ExerciseResultImg
                    className="img-fluid"
                    src={ExerciseWon}
                    alt="برد"
                  />
                </div>
              ) : (
                <div>
                  <ExerciseResultImg
                    className="img-fluid"
                    src={ExerciseLose}
                    alt="باخت"
                  />
                </div>
              )}
            </div>
          </Container>
        )}
      </>
    );
  };

  return (
    <StyledAccordion flush className="bg-white">
      <StyledExerciseAccordionItem eventKey="0">
        <ContextAwareToggle title="شرح تمرین" eventKey="0" />
        <Accordion.Body>
          <ReactMarkdown>
            {ExerciseData.description || ExerciseData.exercise_set.description}
          </ReactMarkdown>
          <img
            src={ExerciseData?.pic_path || ExerciseData?.exercise_set?.pic_path}
            alt="شرح تمرین"
            className="img-fluid"
          />
        </Accordion.Body>
      </StyledExerciseAccordionItem>
      <StyledExerciseAccordionItem
        eventKey="1"
      >
        <ContextAwareToggle title="شبیه‌ساز" eventKey="1" />
        <Accordion.Body>
          <p>برای انجام تمرین در محیط شبیه ساز به تب آزمایش مراجعه کنید</p>
        </Accordion.Body>
      </StyledExerciseAccordionItem>
      {isExcel ? (
        <ExerciseTable />
      ) : (
        <p className="text-center mt-5">
          قسمت شرح تمرین را مطالعه و پاسخ خود را در گزارش‌کار ثبت کنید.
        </p>
      )}
    </StyledAccordion>
  );
};

export default ExerciseTabComponent;
